import { connect } from 'react-redux'
import { filterUtils } from '@opallabs/kuiper'
import { ContentFilter } from '@opallabs/starchart'
import { actions, BulkWrapper } from '@opallabs/wormhole'
import PlacementsPreviewer from '../PlacementsPreviewer'
import { isOnCorrectDay } from './helpers'

const analyzedContent = ({ date, content, filter }) => {
  const analyzedContentResults = {
    idPairs: [],
    filteredContent: [],
    placementContentMap: {
      unplaced: [],
    },
  }

  analyzedContentResults.idPairs = content.reduce((acc, currentContent) => {
    if (!currentContent.moment) {
      return acc
    }

    const matchesFilters = ContentFilter.matchesFilter({
      content: currentContent,
      filter,
    })

    if (matchesFilters && isOnCorrectDay(currentContent, date)) {
      const idPair = {
        postId: currentContent.id,
        momentId: currentContent.moment.id,
      }
      const placementId =
        currentContent.placement && currentContent.placement.id

      analyzedContentResults.filteredContent.push(currentContent)

      if (placementId) {
        if (!analyzedContentResults.placementContentMap[placementId]) {
          analyzedContentResults.placementContentMap[placementId] = []
        }

        analyzedContentResults.placementContentMap[placementId].push(idPair)
      } else {
        analyzedContentResults.placementContentMap.unplaced.push(idPair)
      }

      acc.push(idPair)
    }
    return acc
  }, analyzedContentResults.idPairs)

  return analyzedContentResults
}

const mapStateToProps = (state, props) => {
  const appState = new BulkWrapper(state)
  let account = {}
  let placements = []
  let service = {}
  const content = appState.content || []
  const labelSets = appState.label_set || []
  const labels = appState.labels || []

  if (appState.account) {
    account = appState.account.find(
      (anAccount) => anAccount.id === props.accountId
    )

    placements = account.placements
    service = account.service
  }

  const filter = { account: [{ id: props.accountId }] }
  const analyzedContentResults = analyzedContent({
    date: props.date,
    content,
    filter,
  })
  const filterTree = filterUtils.buildFilterTree(
    {
      labelSets,
      labels,
    },
    [{ name: 'Approval Status' }, { name: 'Labels' }]
  )

  return {
    content: analyzedContentResults.filteredContent,
    idPairs: analyzedContentResults.idPairs,
    placementContentMap: analyzedContentResults.placementContentMap,
    placements,
    account,
    service,
    brandId: state.current_workspace_id,
    filterTree,
  }
}

const mapDispatchToProps = (dispatch) => ({
  getContent: (params) => dispatch(actions.getContent(params)),
  getAccount: (params) => dispatch(actions.getAccount(params)),
  getLabels: (params) => {
    dispatch(actions.getLabelsV2(params))
  },
})

const ConnectedPlacementsPreviewer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlacementsPreviewer)

export default ConnectedPlacementsPreviewer
